import { atom } from 'nanostores';

import type { CurrentUser } from '../types/page';
import { resetUserConfig } from './app.storage';
export * from './app.storage';
export * from './player.storage';

const ACCESS_TOKEN_KEY = 'bgmer.accessToken';

export type BangumiTokenStatus = 'checking' | 'invalid' | 'missing' | 'unchecked' | 'unavailable' | 'valid';

export const $accessToken = atom(localStorage.getItem(ACCESS_TOKEN_KEY) ?? '');
export const $bangumiTokenStatus = atom<BangumiTokenStatus>('unchecked');
export const $currentUser = atom<CurrentUser | undefined>();
export const $scheduleSelectedDay = atom(new Date().getDay() || 7);

export const setAccessToken = (accessToken: string): void => {
  $accessToken.set(accessToken);
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};

export const clearSession = (): void => {
  $accessToken.set('');
  $bangumiTokenStatus.set('unchecked');
  $currentUser.set(undefined);
  resetUserConfig();
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};
